import React, { PureComponent } from "react";
import { Redirect, Link } from "react-router-dom";
import {
  Button,
  Row,
  Col,
  Input,
  Layout,
  Form,
  Alert,
  Modal,
  message,
  Switch,
  Table,
  Space,
  Spin,
  Select,
} from "antd";
import "@ant-design/compatible/assets/index.css";

import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Config from "../Config"; // "../../../Config";
import { Helmet } from "react-helmet";

import { connect } from "react-redux";
import {
  setConfig,
  ajaxHandler,
  ajaxViewHandler,
} from "../store/actions"; //"../../../store/actions";

import axios from "axios";
import moment from "moment";

import { Column, Pie } from "@antv/g2plot";

import Cookies from "js-cookie";
import QRCode from "qrcode.react";
import $ from "jquery";

import "antd/dist/antd.css";


class DashboardPusatData extends PureComponent {
  config;
  // timeoutGetQr;
  // timeOutPushQr;

  constructor(props) {
    super(props);
    this.config = new Config();
    this.state = {
      bulan: parseFloat(moment().format("MM")),
      tahun: moment().format("YYYY"),
      kpl_nama: "",
      pr_nama: "",

      dataTahun: [],

    };
  }

  UNSAFE_componentWillMount() { }

  componentDidMount() {
    this.setState({modal_pengumuman: false})
  }

  componentDidUpdate(prevProps) {

  }

  tabProses(tabData) {
    const key = tabData.key;
    var tempTabs = this.props.tabs;
    var isExist = false;
    tempTabs.map((item) => {
      if (item.key == key) {
        isExist = true;
      }
    });
    if (isExist) {
      this.props.setConfig({
        activeKey: tabData.key,
      });
    } else {
      tempTabs = [
        ...tempTabs,
        {
          title: tabData.title,
          content: tabData.content,
          key: tabData.key,
        },
      ];
      this.props.setConfig({
        tabs: tempTabs,
        activeKey: tabData.key,
      });
    }
  }

  render() {
    return (
      <>
        <div className="row tab-content">
          {/*<!-- Tab Beranda -->*/}

          <div className="col-12">
            <div className="row align-items-center">
              {/* <div className="row align-items-center" style={{ height: "calc(100vh - (1/3 * 100vh))" }}> */}
              <div className="col-12 justify-content-center">
                <div className="card">
                  <div className="card-content collapse show">
                    <div className="card-body text-center">
                      <h5>
                        <b>PUSAT DATA HASIL LAYANAN SISTEM INFORMASI MANAJEMEN LALU LINTAS ANGKUTAN LAUT (SIMLALA)</b>
                      </h5>
                    </div>
                    <div className="card-body text-center">
                      {/* <label className="col-12"> */}
                      <h6>DIREKTORAT LALU LINTAS DAN ANGKUTAN LAUT</h6>
                      <h6>DIREKTORAT JENDERAL PERHUBUNGAN LAUT</h6>
                      <h6>KEMENTERIAN PERHUBUNGAN</h6>
                      {/* </label> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row align-items-center">
              {/* <div className="row align-items-center" style={{ height: "calc(100vh - (1/3 * 100vh))" }}> */}
              <div className="col-12 justify-content-center">
                <div className="card">
                  <div className="card-content collapse show">
                    <div className="card-body text-left">
                      <h5>
                        <b>Layanan E-LICENSING</b>
                      </h5>
                      <ol>
                        <li>Surat Izin Usaha Perusahaan Angkutan Laut <b>(SIUPAL)</b></li>
                        <li>Surat Izin Operasi Angkutan Laut Khusus <b>(SIOPSUS)</b></li>
                      </ol>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row align-items-center">
              {/* <div className="row align-items-center" style={{ height: "calc(100vh - (1/3 * 100vh))" }}> */}
              <div className="col-12 justify-content-center">
                <div className="card">
                  <div className="card-content collapse show">
                    <div className="card-body text-left">
                      <h5>
                        <b>Layanan E-SERVICE</b>
                      </h5>
                      <ol>
                        <li>Spesifikasi Kapal <b>(SPEK)</b> yang dimiliki/charter PAL/PAL Khusus</li>
                        <li>Rencana Pengoperasian Kapal <b>(RPK)</b> Liner</li>
                        <li>Rencana Pengoperasian Kapal <b>(RPK)</b> Tramper</li>
                        <li>Rencana Pengoperasian Kapal <b>(RPK)</b> Khusus</li>
                        <li>Pemberitahuan Keagenan Kapal Asing (PKKA)</li>
                        <li>Pembukaan Kantor Cabang</li>
                        <li>Ijin Penggunaan Kapal Asing (IPKA)</li>
                        <li>Layanan PPKN</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*<!-- End Tab Beranda -->*/}
          <Modal
            zIndex={10000}
            width={"25%"}
            title={
              <h4 className="modal-title text-bold-500 white">
                Pengumuman
              </h4>
            }
            visible={this.state.modal_pengumuman}
            onCancel={() => {
              this.setState({
                modal_pengumuman: false,
              });
            }}
            footer={[
              <button
                key="btn-keluar-jenis"
                type="button"
                className="btn btn-sm grey btn-danger round mr-1"
                data-dismiss="modal"
                onClick={() => {
                  this.setState({
                    modal_pengumuman: false,
                  });
                }}
              >
                Tutup
              </button>,
            ]}
          >
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group row mx-auto last">
                    <label className="col-md-12 label-control">Sistem sedang dalam proses perbaikan, kami mohon maaf atas ketidaknyamanannya</label>
                  </div>
                </div>
              </div>
          </Modal>
        </div>
        {/*<!-- End Tab Beranda -->*/}
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  setConfig,
  ajaxHandler,
  ajaxViewHandler,
})(DashboardPusatData);
